const ReviewsIndex = () =>
  import(/* webpackChunkName: 'reviewsIndex' */ '@/pages/review/pages/index.vue')
const ReviewsAppeal = () =>
  import(/* webpackChunkName: 'reviewsAppeal' */ '@/pages/review/pages/appeal/index.vue')

const routes = [
  {
    path: '/reviews',
    name: 'reviews',
    component: ReviewsIndex,
    children: [
      {
        path: 'appeal',
        name: 'ReviewsAppeal',
        component: ReviewsAppeal,
      },
    ],
  },
]

export default routes
